import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { VenueProvider } from "@/context/VenueContext";
import { LangProvider } from "@/i18n";
import PlusLogin from "@/pages/plus/PlusLogin";
import PlusHome from "@/pages/plus/PlusHome";
import PlusCustomer from "@/pages/plus/PlusCustomer";
import PlusNewCustomer from "@/pages/plus/PlusNewCustomer";
import PlusAdmin from "@/pages/plus/PlusAdmin";
import PlusCatalog from "@/pages/plus/PlusCatalog";
import PlusDemo from "@/pages/plus/PlusDemo";
import PlusManage from "@/pages/plus/PlusManage";
import PlusPlatform from "@/pages/plus/PlusPlatform";
import PlusDashboard from "@/pages/plus/PlusDashboard";
import PlusCockpit from "@/pages/plus/PlusCockpit";

function PlusProtected({ children, adminOnly, manageOnly, platformOnly }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-zinc-950 flex items-center justify-center text-zinc-400">...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.ruolo !== "ADMIN") return <Navigate to="/" replace />;
  if (manageOnly && !["GROUP_OWNER", "PLATFORM_OWNER"].includes(user.role)) return <Navigate to="/" replace />;
  if (platformOnly && user.role !== "PLATFORM_OWNER") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App bg-zinc-950 min-h-screen text-white">
      <LangProvider>
        <BrowserRouter>
          <AuthProvider>
            <VenueProvider>
              <Routes>
                <Route path="/login" element={<PlusLogin />} />
                <Route path="/" element={<PlusProtected><PlusHome /></PlusProtected>} />
                <Route path="/customers/new" element={<PlusProtected><PlusNewCustomer /></PlusProtected>} />
                <Route path="/customers/:id" element={<PlusProtected><PlusCustomer /></PlusProtected>} />
                <Route path="/catalog" element={<PlusProtected><PlusCatalog /></PlusProtected>} />
                <Route path="/demo" element={<PlusProtected><PlusDemo /></PlusProtected>} />
                <Route path="/manage" element={<PlusProtected manageOnly><PlusManage /></PlusProtected>} />
                <Route path="/dashboard" element={<PlusProtected manageOnly><PlusDashboard /></PlusProtected>} />
                <Route path="/cockpit/:groupId" element={<PlusProtected><PlusCockpit /></PlusProtected>} />
                <Route path="/platform" element={<PlusProtected platformOnly><PlusPlatform /></PlusProtected>} />
                <Route path="/admin" element={<PlusProtected adminOnly><PlusAdmin /></PlusProtected>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </VenueProvider>
          </AuthProvider>
        </BrowserRouter>
        <Toaster position="top-center" richColors theme="dark" />
      </LangProvider>
    </div>
  );
}

export default App;
